<template>
    <v-app>
        <v-container fluid>
            <template v-if="$insertAccess($route.path)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel">
                                <v-expansion-panel>
                                    <v-expansion-panel-title
                                    color="blue-grey-lighten-4"
                                    class="panel-header"
                                    >
                                        <span>
                                            {{ isEntryMode ? "Add Employee Target" : "Update Employee Target" }}
                                        </span>
                                    </v-expansion-panel-title>

                                    <v-expansion-panel-text>
                                        <v-row class="px-2 py-2 no-gutters ">
                                            <v-col  md="3" cols="12">
                                                
                                                <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="department_id.value.value"
                                                :items="getHrmDepartmentList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="department_id.errorMessage.value"
                                                :loading="deparment_loading"
                                                autocomplete="off"
                                                
                                                clearable
                                                >
                                                    <template #label>
                                                        Department
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>

                                                <v-autocomplete
                                                    label="Sales Team Target"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    v-model="sales_target_master_parent_id.value.value"
                                                    :items="getSalesTeamTargetList"
                                                    :item-title="(item) => `${item.code}`"
                                                    item-value="id"
                                                    :error-messages="sales_target_master_parent_id.errorMessage.value"
                                                    autocomplete="off"
                                                    :loading="sale_team_target_loading"
                                                    :disabled="salesTeamTargetReadonly"
                                                    clearable
                                                    >
                                                    <template #label>
                                                        Sales Team Target
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>
                                                
                                                <v-number-input
                                                v-model="getTotalTargetAmount"
                                                label="Total Target Amount"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                class="ma-0"
                                                control-variant="hidden"
                                                :disabled="totalTargetAmountDisable"
                                                :error-messages="totalTargetError"
                                                clearable>
                                                    <template #label>
                                                        Total Target Amount
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-number-input>
                                            </v-col>
                                            
                                            <v-col md="3" cols="12">
                                                <v-autocomplete
                                                label="Sales Team"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="team_master_id.value.value"
                                                :items="getSalesTeams"
                                                :item-title="(item) => `${item.team_name}`"
                                                item-value="id"
                                                :error-messages="team_master_id.errorMessage.value"
                                                autocomplete="off"
                                                :loading="team_loading"
                                                clearable
                                                :disabled="salesTeamReadonly"
                                                >
                                                    <template #label>
                                                        Sales Team
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                                </v-autocomplete>

                                                <v-autocomplete
                                                label="Employee"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_id.value.value"
                                                :items="getHrmTeamsWiseEmployeeList"
                                                :item-title="item => `${item.code}-${item.name}` ?? 'N/A'"
                                                item-value="id"
                                                :error-messages="employee_id.errorMessage.value"
                                                autocomplete="off"
                                                :loading="employee_loading"
                                                clearable
                                                :disabled="employeeReadOnly"
                                                >
                                                    <template #label>
                                                        Employee
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                                </v-autocomplete>

                                            </v-col>
                                            
                                            <v-col md="3" cols="12">
                                                <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Start Date"
                                                density="compact"
                                                variant="outlined"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                bg-color="grey-lighten-4"
                                                v-model="start_date.value.value"
                                                :error-messages="start_date.errorMessage.value"
                                                autocomplete="off" 
                                                disabled
                                                clearable
                                                >
                                                    <template #label>
                                                        Start Date
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-date-input>  
                                                
                                                <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="period_type.value.value"
                                                :items="period_types"
                                                :item-title="(item) => `${item.text}`"
                                                item-value="value"
                                                :error-messages="period_type.errorMessage.value"
                                                autocomplete="off"
                                                disabled
                                                clearable
                                                >
                                                    <template #label>
                                                        Period Type
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            
                                            <v-col md="3" cols="12">
                                                <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="End Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="end_date.value.value"
                                                :error-messages="end_date.errorMessage.value"
                                                autocomplete="off"
                                                disabled
                                                clearable
                                                >
                                                    <template #label>
                                                        End Date
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-date-input>  

                                                <v-number-input
                                                    v-model="team_total_target.value.value"
                                                    label="Team Total Target"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="ma-0"
                                                    control-variant="hidden"
                                                    :disabled="true"
                                                    clearable/>

                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                    <container fluid style="margin-top: -20px;">
                        <v-row>
                            <v-col>
                                <v-expansion-panels v-model="contactPersonInfo">
                                    <v-expansion-panel>
                                        <v-expansion-panel-title
                                        color="blue-grey-lighten-4"
                                        class="panel-header"
                                        ><span>{{
                                        isEntryMode
                                            ? "Target Details"
                                            : "Update Target Details"
                                        }}</span></v-expansion-panel-title
                                        >

                                        <v-expansion-panel-text>
                                            <v-row v-if="!contacts.length">
                                                <v-col cols="12" class="my-5 d-flex justify-center">
                                                    <div>  
                                                        <v-btn @click="addContactRow" variant="tonal" color="primary"> <v-icon color="info" icon="mdi-plus" size="large" ></v-icon>Add Details</v-btn>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-row
                                            v-for="(contact, index) in contacts"
                                            :key="index"
                                            class="px-2 py-2"
                                            align="center"
                                            no-gutters
                                            dense
                                            >
                                                <v-col cols="12" md="3" class="pr-4 pa-0">
                                                    <v-autocomplete
                                                        label="Target Type"
                                                        variant="outlined"
                                                        density="compact"
                                                        bg-color="grey-lighten-4"
                                                        v-model="contact.target_type"
                                                        :items="target_type"
                                                        :item-title="(item) => `${item.text}`"
                                                        item-value="value"
                                                        autocomplete="off"
                                                        class="pr-4"
                                                        clearable
                                                    >
                                                        <template #label>
                                                            Target Type
                                                            <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>

                                                <v-col
                                                    v-if="contact.target_type === 'Customer'"
                                                    cols="12" md="3" class="pr-4 pa-0"
                                                >
                                                    <v-autocomplete
                                                        label="Customer Name"
                                                        variant="outlined"
                                                        density="compact"
                                                        bg-color="grey-lighten-4"
                                                        v-model="contact.customer_id"
                                                        :items="getCustomerList"
                                                        :item-title="(item) => `${item.company_owner_name}`"
                                                        item-value="id"
                                                        :loading="customer_loading"
                                                        autocomplete="off"
                                                        class="pr-4"
                                                        clearable
                                                    >
                                                        <template #label>
                                                            Customer Name
                                                            <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>

                                                <v-col
                                                    v-if="contact.target_type === 'Product'"
                                                    cols="12" md="3" class="pr-4 pa-0"
                                                >
                                                    <v-autocomplete
                                                        label="Product Name"
                                                        variant="outlined"
                                                        density="compact"
                                                        bg-color="grey-lighten-4"
                                                        v-model="contact.product_id"
                                                        :items="getProductList"
                                                        :item-title="item => `${item.code}-${item.name}` ?? 'N/A'"
                                                        item-value="id"
                                                        :loading="product_loading"
                                                        autocomplete="off"
                                                        class="pr-4"
                                                        clearable
                                                    >
                                                        <template #label>
                                                            Product Name
                                                            <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>

                                                <v-col cols="6" sm="4" md="3" class="pr-4 pa-0">
                                                    <v-number-input
                                                    v-model="contact.target_amount"
                                                    label="Target Amount"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="ma-0"
                                                    control-variant="hidden"
                                                    clearable
                                                    >
                                                        <template #label>
                                                            Target Amount
                                                            <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-number-input>
                                                </v-col>

                                                <v-col cols="6" sm="4" md="2" class="pr-4 pa-0">
                                                    <v-number-input
                                                    v-model="contact.target_quantity" 
                                                    label="Target Quantity"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="ma-0"
                                                    control-variant="hidden"/>
                                                </v-col>

                                                <v-col sm="4" md="1" class="d-flex justify-center mb-5">
                                                    <v-btn
                                                    @click="removeContactRow(index)"
                                                    variant="tonal"
                                                    color="primary"
                                                    
                                                    >
                                                    <v-icon
                                                        color="red"
                                                        icon="mdi-delete"
                                                        size="large"
                                                    ></v-icon>
                                                    </v-btn>

                                                    <v-btn
                                                    @click="addContactRow"
                                                    variant="tonal"
                                                    color="primary"
                                                    v-if="index == contacts.length - 1"
                                                    >
                                                    <v-icon
                                                        color="info"
                                                        icon="mdi-plus"
                                                        size="large"
                                                    ></v-icon>
                                                    </v-btn>
                                                </v-col>

                                                <v-divider
                                                    v-if="
                                                    contacts.length > 1 && index !== contacts.length - 1
                                                    "
                                                ></v-divider>
                                            </v-row>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </container>
                    <v-card-actions class="bg-white mt-3 rounded-lg">
                        <v-row class="pt-2">
                            <v-col cols="8">
                                <v-textarea
                                label="Remarks"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="remarks.value.value"
                                :error-messages="remarks.errorMessage.value"
                                autocomplete="off"
                                rows="3"
                                clearable
                                ></v-textarea>
                            </v-col>

                            <v-col cols="4">
                                <v-layout class="justify-end">
                                    <v-btn
                                    class="bg-grey-darken-1 me-2"
                                    variant="flat"
                                    @click="submitForm(0)">
                                        DRAFT
                                    </v-btn>

                                    <v-btn
                                    class="bg-primary"
                                    variant="flat"
                                    @click="submitForm(1)">
                                        {{ isEntryMode ? "POST": "UPDATE" }}
                                    </v-btn>
                                </v-layout>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-form>
            </template>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, reactive, getCurrentInstance, watch } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import formattedDate from "@/plugins/dateFormatter";
import salesDepartmentTarget from "@/store/module/sales/targetManagement/salesDepartmentTarget";

export default {
    components: {},
    data: () => ({
        isEntryMode: true,
        itemsPerPage: 10,
        panel: [0],
        contactPersonInfo: [0],
        totalTargetAmountDisable: false,
        manualTargetAmount:0,
        loading: false,
        deparment_loading: false,
        customer_loading: false,
        product_loading: false,
        team_loading: false,
        sale_team_target_loading: false,
        employee_loading: false,

        salesTeamReadonly: true,
        salesTeamTargetReadonly: true,
        customerReadonly: true,
        employeeReadOnly: true,
        
        search: "",
        data: {},

        departmentTargetId: null,
        salesTeamId: null,

        target_type: [
            { text: "Customer", value: "Customer" },
            { text: "Product", value: "Product" },
        ],
        period_types: [
            { text: "Monthly", value: "monthly" },
            { text: "Quarterly", value: "quarterly" },
            { text: "Anually", value: "annual" },
        ],
    }),
    watch: {
        departmentTargetId(newV) {
            if(newV === null || newV === undefined || newV === '') {
                this.$store.commit("UNSET_SALES_TEAM_LIST");

                this.salesTeamReadonly = true;
                return;
            }else{
                const data = { department_id: newV }
                this.team_loading = true;
                
                this.$store.dispatch("getSalesTeams", data).then((response) => {
                    this.salesTeamReadonly = false;
                    this.team_loading = false;
                })
            }

        },

        salesTeamId(newV) {
            if(newV === null || newV === undefined || newV === '') {
                this.$store.commit("UNSET_SALES_TEAM_TARGET_LIST");
                this.$store.commit("UNSET_HRM_TEAM_WISE_EMPLOYEE_LIST");

                this.salesTeamTargetReadonly = true;
                this.employeeReadOnly = true;
                return;
            }else{
                const data = { team_master_id: newV }
                this.sale_team_target_loading = true;
                this.employee_loading = true;

                this.$store.dispatch("getSalesTeamTargetList", data).then((response) => {
                    this.salesTeamTargetReadonly = false;
                    this.sale_team_target_loading = false;
                })
                this.$store.dispatch("getTeamWiseEmployeeList", data).then((response) => {
                    this.employeeReadOnly = false;
                    this.employee_loading = false;
                })
            }

        },

        "department_id.value.value"(val) {
            this.departmentTargetId = val;
        },

        "team_master_id.value.value"(val) {
            this.salesTeamId = val;
        },

        "sales_target_master_parent_id.value.value"(val) {
            if(val === null || val === undefined) {
                this.start_date.value.value = null;
                this.end_date.value.value = null;
                this.period_type.value.value = null;
                this.team_total_target.value.value = 0;
            }else{
                this.$store.dispatch("getSaleTeamTargetById",val).then((response) => {
                    this.start_date.value.value = response.start_date;
                    this.end_date.value.value = response.end_date;
                    this.period_type.value.value = response.period_type;
                    this.team_total_target.value.value = Number(response.target_amount);
                })
            }
        }
    },
    created() {
        if(this.$store.getters.getHrmDepartmentList.length == 0) {
            this.deparment_loading = true;
            this.$store.dispatch("getHrmDepartmentList").then((response) => {
                this.deparment_loading = false;
            });
        }
        if (this.$store.getters.getCustomerList.length == 0) {
            this.customer_loading = true;
            this.$store.dispatch("getCustomerList").then((response) => {
                this.customer_loading = false;
            });
        }
        if (this.$store.getters.getProductList.length == 0) {
            this.product_loading = true;
            this.$store.dispatch("getProductList").then((response) => {
                this.product_loading = false;
            });
        }
    },

    computed: {
        getTotalTargetAmount: {
            get() {
                return this.contacts.length ? this.contacts.reduce((acc, item) => acc + (Number(item.target_amount) || 0), 0) : Number(this.manualTargetAmount);
            },
            set(newValue) {
                // if (!this.contacts.length) {
                //     this.contacts.push({
                //         target_type: "Product",
                //         customer_id: null,
                //         product_id: null,
                //         target_amount: newValue,
                //         target_quantity: null,
                //     });
                //     return;
                // }
                // this.contacts[0].target_amount = Number(newValue);
                this.manualTargetAmount = Number(newValue);
            }
        },
        getHrmDepartmentList() {
            return this.$store.getters.getHrmDepartmentList;
        },
        getCustomerList() {
            return this.$store.getters.getCustomerList;
        },
        getProductList() {
            return this.$store.getters.getProductList;
        },
        getSalesTeams() {
            return this.$store.getters.getSalesTeams;
        },
        getSalesTeamTargetList() {
            return this.$store.getters.getSalesTeamTargetList;
        },
        getHrmTeamsWiseEmployeeList() {
            return this.$store.getters.getHrmTeamwiseEmployeeList;
        },
    },

    methods: {
        resetForm() {
            this.data = {};
        },
    },

    setup() {
        const { proxy } = getCurrentInstance();

        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                sales_target_master_parent_id: yup.string().required().label("Sales Department Target"),
                team_master_id: yup.string().required().label("Sales Team"),
                employee_id: yup.string().required().label("Employee"),
                department_id: yup.string().required().label("Department"),
                period_type: yup.string().required().label("Period Type"),
                start_date: yup.date().required().label("Start Date"),
                end_date: yup.date().required().label("End Date"),
            }),
        });

        const sales_target_master_parent_id = useField("sales_target_master_parent_id");
        const team_master_id = useField("team_master_id");
        const sales_target_master_id = useField("sales_target_master_id");
        const department_id = useField("department_id");
        const employee_id = useField("employee_id");
        const period_type = useField("period_type");
        const start_date = useField("start_date");
        const end_date = useField("end_date");
        const remarks = useField("remarks");
        const status = useField("status");
        const target_details = useField("target_details");
        const team_total_target = useField("team_total_target");

        const contacts = ref([
            // {
            //     target_type: "Product",
            //     customer_id: null,
            //     product_id: null,
            //     target_amount: null,
            //     target_quantity: null,
            // },
        ]);

        watch(contacts, (newContacts) => {
            if(contacts.value.length >= 1)  proxy.totalTargetAmountDisable = true;
            else proxy.totalTargetAmountDisable = false;
        }, { deep: true });

        const currentStatus = ref(0);

        const contactErrors = reactive({});
        const errorMessages = ref("");
        const loading = ref("");
        const isEntryMode = ref(true);
        const totalTargetError = ref("");

        const store = useStore();
        const router = useRouter();

        const addContactRow = () => {
            contacts.value.push({
                target_type: "Product",
                customer_id: null,
                product_id: null,
                target_amount: null,
                target_quantity: null,
            });
        };
        const removeContactRow = (index) => {
            if (contacts.value.length >= 1) {
                contacts.value.splice(index, 1);
            }
        };

        const submitForm = (status) => {
            currentStatus.value = status;
            const totalAmount = proxy.getTotalTargetAmount;
            if (!totalAmount || Number(totalAmount) <= 0) {
                totalTargetError.value = "Total Target Amount must be greater than 0";
            } else {
                totalTargetError.value = "";
            }
            submit();
        };
        const submit = handleSubmit((values) => {
            const totalAmount = proxy.getTotalTargetAmount;
            const invalidTargetAmount = contacts.value.find(
                item => !item.target_amount 
            );  

            const invalidRow = contacts.value.find(
                (item) => !item.customer_id && !item.product_id
            );

            if (invalidTargetAmount && contacts.value.length === 1 ) {
                toast.error("Every Detail must have Target Amount");
                return;
            } else if (invalidRow || invalidTargetAmount) {
                if(contacts.value.length >= 1 && invalidTargetAmount){
                    toast.error("Every Detail must have Target Amount");
                    return;
                }
                toast.error("Every Detail must have Customer or Product Info");
                return;
            }
            
            values.department_id = proxy.departmentTargetId;
            values.status = currentStatus.value;
            values.target_details = contacts.value || [];
            values.start_date = formattedDate(start_date.value.value);
            values.end_date = formattedDate(end_date.value.value);
            values.target_amount = totalAmount;

            loading.value = true;
            store
                .dispatch("saveUpdateSalesEmployeeTarget", values)
                .then((response) => {
                    resetForm();
                    contacts.value = [
                        // {
                        //     target_type: "Product",
                        //     customer_id: null,
                        //     product_id: null,
                        //     target_amount: null,
                        //     target_quantity: null,
                        // },
                    ];
                    loading.value = false;
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "employee-target-records" });
                    }, 2000);
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error.response?.data?.message || "An error occurred");
                });
        });

        return {
            submit,
            submitForm,

            sales_target_master_parent_id,
            team_master_id,
            sales_target_master_id,
            department_id,
            employee_id,
            period_type,
            start_date,
            end_date,
            target_details,
            remarks,
            status,
            team_total_target,

            contacts,
            addContactRow,
            removeContactRow,
            errorMessages,
            isEntryMode,
            resetForm,
            loading,
            contactErrors,
            totalTargetError,
        };
    },

    mounted() {
        if (this.$store.getters.getEditingSalesEmployeeTarget) {
            this.isEntryMode = false;
            const data = this.$store.getters.getEditingSalesEmployeeTarget;

            this.sales_target_master_id.value.value = data.id;
            this.team_master_id.value.value = data.sales_team.id;
            this.department_id.value.value = data.department_id
            this.employee_id.value.value = data.employee_id;
            this.sales_target_master_parent_id.value.value = data.sales_target_master_parent_id;
            this.period_type.value.value = data.period_type;
            this.start_date.value.value = data.start_date;
            this.end_date.value.value = data.end_date;
            this.manualTargetAmount = data.target_amount || 0;
            this.remarks.value.value = data.remarks;

            this.contacts = data.sales_target_details?.length ? data.sales_target_details.map((detail) => ({
                target_type: detail.target_type || "Product",
                customer_id: detail.customer_id || null,
                product_id: detail.product_id || null,
                target_amount: Number(detail.target_amount) || 0,
                target_quantity: Number(detail.target_quantity) || 0,
            }))
            : [
                // {
                //     target_type: "Product",
                //     customer_id: null,
                //     product_id: null,
                //     target_amount: null,
                //     target_quantity: null,
                // },
            ];

            // this.contacts = data.sales_target_details || [
            //     // {
            //     //     target_type: "Product",
            //     //     customer_id: null,
            //     //     product_id: null,
            //     //     target_amount: null,
            //     //     target_quantity: null,
            //     // },
            // ];
        }else{
            this.isEntryMode = true;
            this.resetForm();
            this.contacts = [
                // {
                //     target_type: "Product",
                //     customer_id: null,
                //     product_id: null,
                //     target_amount: null,
                //     target_quantity: null,
                // },
            ];
        }
    },
    beforeUnmount() {
        this.$store.commit("seteditingSalesEmployeeTarget", null);
    },
    
};
</script>
